import TrainingSessionLessonContent from '../session-lesson-content';

/**
 * Create the action
 */

const { thunk, request, success, error } = TrainingSessionLessonContent.update((data, fetch) => {
    // Prepare request
    let formData = new FormData();
    formData.append('_method', 'PUT');
    ['block_type', 'block_data', 'order_index', 'file']
        .map(key => data[key] !== undefined ? formData.append(key, data[key]) : null);
    
    return fetch.post(`/trainings/${data.trainingId}/sessions/${data.sessionId}/lessons/${data.lessonId}/contents/${data.contentId}`, formData);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
